import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Box, IconButton, Menu, Tooltip } from "@material-ui/core";
import { fade, makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import PaymentsIcon from "@mui/icons-material/Payments";
import HelpIcon from "@mui/icons-material/Help";
import Divider from "@mui/material/Divider";
import MenuItem from "@mui/material/MenuItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import LogoutIcon from "@mui/icons-material/Logout";
import Avatar from "@mui/material/Avatar";
import CircularProgress from "@mui/material/CircularProgress";
import Badge from "@material-ui/core/Badge";
import Button from "@mui/material/Button";
import NotificationsIcon from "@material-ui/icons/Notifications";
import StarsIcon from "@mui/icons-material/Stars";
import DescriptionIcon from "@mui/icons-material/Description";
import InviteTeacher from "../components/InviteTeacher";
import RatingCourse from "../components/RatingCourse";
import StudentTutorial from "../components/StudentTutorial/StudentTutorial";

// import Stack from '@mui/material/Stack';
// import Snackbar from '@mui/material/Snackbar';
// import Alert from '@mui/material/Alert';

import SwipeableTopDrawer from "../components/SwipeableTopDrawer";
import CourseMenu from "../components/CourseMenu";
import TabsMenu from "../components/TabsMenu";
// import { addUser } from '../store/user.actions';
// import { selectCourse } from '../store/course.actions';
// import { setMyCourses } from '../store/mycourses.actions';
// import { setTopicTree, setTopicList, setKeywordList, setTopicTreeLearning, setTopicListLearning, setKeywordListLearning, setTopicTreeTest, setTopicListTest, setSmartLearning, setMockTest } from '../store/data.actions';
import axios from "axios";
import { API_URL, WHITE_LABEL_LOGO_URL } from "../utils/EnvVars";
import { useDispatch, useSelector } from "react-redux";
import {  setTutorialExpanded, toggleTutorial } from "../store/tutorial.actions";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
  },
  grow: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: fade(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
  },
  sectionDesktop: {
    display: "none",
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  },
  sectionMobile: {
    display: "flex",
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

export default function Header(props) {
  let history = useHistory();
  const dispatch = useDispatch();
  const showCard = useSelector((state) => state.tutorial);

  // const userObj = useSelector(state => state.userDetails);
  const childRefInviteTeacher = React.useRef();
  const childRefRatingCourse = React.useRef();

  var etlStudentObj = JSON.parse(localStorage.getItem("etlStudentObj"));
  var selectedCourse = localStorage.getItem("etlSelectCourse");
  var mySelectedCourses = JSON.parse(localStorage.getItem("etlMyCourses"));
  var deviceType = localStorage.getItem("deviceType");

  const [organisationName, setOrganisationName] = React.useState("");

  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [showAlert, setShowAlert] = React.useState(false);
  const [alertMessage, setAlertMessage] = React.useState("");

  const [notificationCounter, setNotificationCounter] = React.useState(0);
  const [notifications, setNotifications] = React.useState([]);
  const [alertNotifications, setAlertNotifications] = React.useState([]);
  const [anchorElNots, setAnchorElNots] = React.useState(null);
  const isNotsMenuOpen = Boolean(anchorElNots);
  const menuId = "notication-menuId";

  const [anchorElUser, setAnchorElUser] = React.useState(null);
  const classes = useStyles();

  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);
  };
  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
    dispatch(setTutorialExpanded(false));
  };

  const handleNotsMenu = (event) => {
    if (!anchorElNots) {
      getApiDataNotifications();
      setAnchorElNots(event.currentTarget);
    } else {
      setAnchorElNots(null);
    }
  };
  const handleCloseNotsMenu = () => {
    setAnchorElNots(null);
  };

  function goToLocation(url) {
    history.push(url);
  }
  function logout() {
    window.location.href = "logout";
  }

  React.useEffect(() => {
    if (
      etlStudentObj &&
      (!etlStudentObj.emailId || etlStudentObj.emailId.length < 1)
    ) {
      setNotificationCounter(1);
    }
    if (
      mySelectedCourses &&
      selectedCourse >= 0 &&
      mySelectedCourses[selectedCourse] &&
      mySelectedCourses[selectedCourse].organisationName
    ) {
      setOrganisationName(mySelectedCourses[selectedCourse].organisationName);
      // var d1 = new Date();
      // var d2 = new Date(mySelectedCourses[selectedCourse].validTillDate);
      // d2.setDate(d2.getDate() + 1);
      // ////alert("Date>> "+d1.getFullYear()+"-"+d1.getMonth()+"-"+d1.getDate());
      // if(d1>d2 && mySelectedCourses[selectedCourse].subscriptionType==='PAID' && (window.location.pathname.indexOf("selectmocktest")>-1 || window.location.pathname.indexOf("selecttopictest")>-1)){
      //     history.push('validity');
      // }
    }
  }, []);

  async function getApiDataNotifications() {
    let axiosHeader = {
      headers: {
        "Content-Type": "multipart/mixed",
        loginId: etlStudentObj.loginId,
        token: etlStudentObj.token,
        device: "web",
      },
    };
    axios
      .get(API_URL + "/student-invitations", axiosHeader)
      .then((response) => {
        if (response.data.responseTxt === "success") {
          setNotifications(response.data.list);
          return false;
        }
      })
      .catch((error) => {
        // setSeverityAlert("error");
        // setShowAlert(true);
        // setAlertMessage(""+error);
        // return false;
      });
  }

  React.useEffect(() => {
    if (etlStudentObj) {
      getApiDataInvitationCounter();
      getApiDataSelectedCourses();
      getApiDataAlertNotifications();
    }

  }, []);

  useEffect(() => {
  
        dispatch(setTutorialExpanded(false));
        
      
      return () => {
      dispatch(setTutorialExpanded(false));
      }
  },[])

  async function getApiDataInvitationCounter() {
    let axiosHeader = {
      headers: {
        "Content-Type": "multipart/mixed",
        loginId: etlStudentObj.loginId,
        token: etlStudentObj.token,
        device: "web",
      },      
    };
    axios
      .get(API_URL + "/student-invitation-counter", axiosHeader)
      .then((response) => {
        if (response.data.responseTxt === "success") {
          if (response.data.counter > 0) {
            setNotificationCounter(response.data.counter);
            if (!etlStudentObj.emailId || etlStudentObj.emailId.length < 1) {
              setNotificationCounter(response.data.counter + 1);
            }
          }
          return false;
        }
      })
      .catch((error) => {
        // setSeverityAlert("error");
        // setShowAlert(true);
        // setAlertMessage(""+error);
        // return false;
      });
  }

  async function getApiDataAlertNotifications() {
    let axiosHeader = {
      headers: {
        "Content-Type": "multipart/mixed",
        loginId: etlStudentObj.loginId,
        token: etlStudentObj.token,
        device: "web",
      },
    };
    axios
      .get(API_URL + "/student-panel-notifications", axiosHeader)
      .then((response) => {
        if (response.data.responseTxt === "success") {
          if (response.data.obj && response.data.obj.length > 0) {
            setAlertNotifications(response.data.obj);
          }
          return false;
        }
      })
      .catch((error) => {
        // setSeverityAlert("error");
        // setShowAlert(true);
        // setAlertMessage(""+error);
        // return false;
      });
  }

  function actionOnInvitation(token, status) {
    let axiosHeader = {
      headers: {
        "Content-Type": "multipart/mixed",
        loginId: etlStudentObj.loginId,
        token: etlStudentObj.token,
        device: "web",
      },
    };

    const data = new FormData();
    data.append("token", token);
    data.append("status", status);

    axios
      .post(API_URL + "/student-actionon-invitation", data, axiosHeader)
      .then((response) => {
        //console.log("RESPONSE RECEIVED: ", response.data.responseTxt);
        if (response.data.responseTxt === "success") {
          getApiDataInvitationCounter();
          setSeverityAlert("success");
          setShowAlert(true);
          setAlertMessage("Your request has been processed successfully");
          return false;
        } else {
          setSeverityAlert("error");
          setShowAlert(true);
          setAlertMessage(
            "Could not be processed your request. Please try after sometime"
          );
          return false;
        }
      })
      .catch((error) => {
        setSeverityAlert("error");
        setShowAlert(true);
        setAlertMessage("" + error);
        return false;
      });
  }

  async function getApiDataSelectedCourses() {
    let axiosHeader = {
      headers: {
        "Content-Type": "multipart/mixed",
        loginId: etlStudentObj.loginId,
        token: etlStudentObj.token,
        device: "web",
      },
    };
    axios
      .get(API_URL + "/student-selected-courses", axiosHeader)
      .then((response) => {
        if (
          response.data.responseTxt === "success" &&
          response.data.obj &&
          response.data.obj.length > 0
        ) {
          //document.write(JSON.stringify(response.data.obj));
          localStorage.setItem(
            "etlMyCourses",
            JSON.stringify(response.data.obj)
          );
          return false;
        }
      })
      .catch((error) => {
        // setSeverityAlert("error");
        // setShowAlert(true);
        // setAlertMessage(""+error);
        // return false;
      });
  }

  function inviteTeacher() {
    childRefInviteTeacher.current.handleClickOpen();
  }

  function ratingCourse() {
    childRefRatingCourse.current.handleClickOpen();
  }

  function upgrade(corseDate, stype, corseTitle) {
    let rtrn = 1;
    if (
      stype === "FREEFOREVER" ||
      (stype === "FREE" && corseTitle.indexOf("FREE FOREVER") > -1)
    ) {
      rtrn = 0;
    } else if (
      stype.indexOf("FREE") === -1 &&
      corseTitle.indexOf("FREE FOREVER") === -1
    ) {
      let d1 = new Date();
      let d2 = new Date(corseDate);
      d2.setDate(d2.getDate() + 1);
      if (d1 > d2) {
        rtrn = 2;
      } else {
        rtrn = 0;
      }
    }
    return rtrn;
  }

  //   function upgrade(corseDate,stype,corseTitle){
  //     let rtrn = 1;
  //     if(stype==='ACE' || stype==='PRO' || stype==='PAID'){
  //       let d1 = new Date();
  //       let d2 = new Date(corseDate);
  //       d2.setDate(d2.getDate() + 1);
  //       if(d1>d2){
  //         rtrn = 2;
  //       }else{
  //         rtrn = 0;
  //       }
  //     }else if(stype==='FREEFOREVER' || (stype==='FREE' && corseTitle.indexOf("FREE FOREVER")>-1)){
  //       rtrn = 0;
  //     }
  //   return rtrn;
  // }

  function goToCourseBuy(cid) {
    window.location.href = "selectcourse?cid=" + cid;
  }


  return (
    <>
      <div className={classes.grow}>
        <AppBar position="fixed" className={classes.appBar}>
          <Toolbar>
            {/* menuOpen={props.menuOpen} */}
            <span className={classes.sectionMobile}>
              <SwipeableTopDrawer />
            </span>
            <span className={classes.sectionDesktop}>
              {window.location.hostname === "localhost" ||
              window.location.hostname === "uat.easetolearn.com" ||
              window.location.hostname === "easetolearn.com" ? (
                <img
                  src={process.env.PUBLIC_URL + "/ease_to_learn_logo.png"}
                  style={{ height: 37, marginRight: 35 }}
                />
              ) : (
                <img
                  src={
                    WHITE_LABEL_LOGO_URL +
                    "/" +
                    window.location.hostname.replace(/\./g, "-") +
                    ".png"
                  }
                  style={{ height: 37, marginRight: 35 }}
                />
              )}
            </span>
            <CourseMenu
              title={
                organisationName && organisationName.length > 0 ? (
                  <>{organisationName}</>
                ) : (
                  "ETL"
                )
              }
            />
            {(!deviceType || (deviceType && deviceType !== "ios")) &&
            mySelectedCourses &&
            mySelectedCourses[selectedCourse] &&
            upgrade(
              mySelectedCourses[selectedCourse].validTillDate,
              mySelectedCourses[selectedCourse].packTypeTitle,
              mySelectedCourses[selectedCourse].organisationName
            ) > 0 ? (
              <Button
                onClick={() => {
                  goToCourseBuy(mySelectedCourses[selectedCourse].courseId);
                }}
                style={{
                  textTransform: "none",
                  height: 20,
                  backgroundColor: "#008140",
                  color: "#FFF",
                }}
                size="small"
                variant="contained"
              >
                {upgrade(
                  mySelectedCourses[selectedCourse].validTillDate,
                  mySelectedCourses[selectedCourse].packTypeTitle,
                  mySelectedCourses[selectedCourse].organisationName
                ) === 2 ? (
                  <>Renew</>
                ) : (
                  <>Upgrade</>
                )}
              </Button>
            ) : null}
            <div className={classes.grow} />

            {notificationCounter ? (
              <IconButton
                onClick={handleNotsMenu}
                aria-controls={menuId}
                size="large"
                aria-label="courses"
                color="inherit"
              >
                <Badge badgeContent={notificationCounter} color="error">
                  <NotificationsIcon />
                </Badge>
                <Menu
                  anchorEl={anchorElNots}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  id={menuId}
                  keepMounted
                  transformOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  open={isNotsMenuOpen}
                  onClose={handleCloseNotsMenu}
                  PaperProps={{
                    style: { minWidth: 220, maxWidth: 300, marginTop: 30 },
                  }}
                >
                  {alertNotifications || alertNotifications.length < 1
                    ? alertNotifications.map((row) => (
                        <MenuItem
                          disableRipple
                          style={{
                            whiteSpace: "normal",
                            cursor: "auto",
                            backgroundColor: "transparent",
                          }}
                        >
                          <ListItemText secondary={<div>{row.message}</div>} />
                        </MenuItem>
                      ))
                    : null}

                  {notifications ? (
                    notifications.map((myRow) => (
                      <MenuItem
                        disableRipple
                        style={{
                          whiteSpace: "normal",
                          cursor: "auto",
                          backgroundColor: "transparent",
                        }}
                      >
                        <ListItemText
                          secondary={
                            <div>
                              <div>
                                Teacher `{myRow.invitedByName}` invited you to
                                join class and allow this teacher to see your
                                progress reports & analytics.{" "}
                              </div>
                              <div>
                                <Button
                                  onClick={() => {
                                    actionOnInvitation(myRow.token, "Accepted");
                                  }}
                                  style={{
                                    textTransform: "none",
                                    height: 20,
                                    backgroundColor: "#008140",
                                    color: "#FFF",
                                  }}
                                  size="small"
                                  variant="outlined"
                                >
                                  Accept
                                </Button>
                                <Button
                                  onClick={() => {
                                    actionOnInvitation(myRow.token, "Rejected");
                                  }}
                                  style={{
                                    marginLeft: 10,
                                    textTransform: "none",
                                    height: 20,
                                    backgroundColor: "#f44336",
                                    color: "#FFF",
                                  }}
                                  size="small"
                                  variant="outlined"
                                >
                                  Reject
                                </Button>
                              </div>
                            </div>
                          }
                        />
                      </MenuItem>
                    ))
                  ) : (
                    <MenuItem
                      disableRipple
                      style={{
                        whiteSpace: "normal",
                        cursor: "auto",
                        backgroundColor: "transparent",
                      }}
                    >
                      <ListItemText
                        secondary={
                          <>
                            <span>
                              <CircularProgress size={20} />
                            </span>{" "}
                            Wait...
                          </>
                        }
                      />
                    </MenuItem>
                  )}

                  {!etlStudentObj.emailId ||
                  etlStudentObj.emailId.length < 1 ? (
                    <MenuItem
                      disableRipple
                      style={{
                        whiteSpace: "normal",
                        cursor: "auto",
                        backgroundColor: "transparent",
                      }}
                    >
                      <ListItemText
                        secondary={
                          <div>
                            <div>
                              Require for online teacher support? Update your
                              email.
                            </div>
                            <div>
                              <Button
                                onClick={() => {
                                  goToLocation("profile");
                                }}
                                style={{
                                  textTransform: "none",
                                  height: 20,
                                  backgroundColor: "#008140",
                                  color: "#FFF",
                                }}
                                size="small"
                                variant="outlined"
                              >
                                Update Email
                              </Button>
                            </div>
                          </div>
                        }
                      />
                    </MenuItem>
                  ) : null}
                </Menu>
              </IconButton>
            ) : (
              <IconButton
                aria-controls={menuId}
                size="large"
                aria-label="courses"
                color="inherit"
              >
                <Badge color="error">
                  <NotificationsIcon />
                </Badge>
              </IconButton>
            )}

            {etlStudentObj ? (
              <Box sx={{ flexGrow: 0 }}>
                <Tooltip
                  title={
                    etlStudentObj.studentName + " " + etlStudentObj.phoneNo
                  }
                >
                  <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                    <Avatar
                      alt={etlStudentObj.studentName}
                      src={
                        etlStudentObj.profilePic &&
                        etlStudentObj.profilePic.length > 0
                          ? etlStudentObj.profilePic
                          : "undefined"
                      }
                      sx={{ width: 33, height: 33 }}
                    />
                  </IconButton>
                </Tooltip>
                <Menu
                  sx={{ mt: "45px" }}
                  id="menu-appbar"
                  anchorEl={anchorElUser}
                  anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  open={Boolean(anchorElUser)}
                  onClose={handleCloseUserMenu}
                >
                  <MenuItem
                    style={{
                      justifyContent: "center",
                      width: 230,
                      cursor: "none",
                    }}
                  >
                    <IconButton sx={{ p: 0, cursor: "none" }}>
                      <Avatar
                        alt={etlStudentObj.studentName}
                        src={
                          etlStudentObj.profilePic &&
                          etlStudentObj.profilePic.length > 0
                            ? etlStudentObj.profilePic
                            : "undefined"
                        }
                        sx={{ width: 50, height: 50, cursor: "none" }}
                      />
                    </IconButton>
                  </MenuItem>
                  <MenuItem>
                    <ListItemText
                      style={{ textAlign: "center", cursor: "none" }}
                    >
                      {etlStudentObj.studentName}
                    </ListItemText>
                  </MenuItem>
                  <MenuItem>
                    <ListItemText
                      style={{ textAlign: "center", cursor: "none" }}
                    >
                      {etlStudentObj.phoneNo}
                    </ListItemText>
                  </MenuItem>
                  <Divider />

                  <MenuItem
                    onClick={() => {
                      dispatch(setTutorialExpanded(false));
                      goToLocation("profile");
                    }}
                  >
                    <ListItemIcon>
                      <AccountCircleIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Profile</ListItemText>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      dispatch(setTutorialExpanded(false));
                      goToLocation("payments");
                    }}
                  >
                    <ListItemIcon>
                      <PaymentsIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Payments</ListItemText>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      dispatch(setTutorialExpanded(false));
                      inviteTeacher();
                    }}
                  >
                    <ListItemIcon>
                      <DescriptionIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Invite Teacher</ListItemText>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      dispatch(toggleTutorial());
                    }}
                  >
                    <ListItemIcon>
                      <HelpIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Tutorials</ListItemText>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      dispatch(setTutorialExpanded(false));
                      ratingCourse();
                    }}
                  >
                    <ListItemIcon>
                      <StarsIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Rate This Course</ListItemText>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      dispatch(setTutorialExpanded(false));
                      goToLocation("feedback");
                    }}
                  >
                    <ListItemIcon>
                      <ErrorOutlineIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Feedback</ListItemText>
                  </MenuItem>

                  <MenuItem
                    onClick={() => {
                      dispatch(setTutorialExpanded(false));
                      logout();
                    }}
                  >
                    <ListItemIcon>
                      <LogoutIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Logout</ListItemText>
                  </MenuItem>
                </Menu>
              </Box>
            ) : null}
          </Toolbar>
        </AppBar>
        <div className={classes.sectionMobile}>
          <TabsMenu />
        </div>
      </div>

      {showCard ? <StudentTutorial /> : <></>}

      <InviteTeacher ref={childRefInviteTeacher} />
      <RatingCourse ref={childRefRatingCourse} />
    </>
  );
}